const Vue              = require('vue').default;
// const VueSmoothScroll  = require('vue2-smooth-scroll').default
// const VueCookies       = require('vue-cookies')
const moment           = require("moment")
// const VueScrollbar  = require('vue2-perfect-scrollbar').default


// Vue.use(VueCookies);
// Vue.use(VueSmoothScroll)
// Vue.use(VueScrollbar)


var CommonVueOperation = {
  data: function(){
    return {
      btnPagetop: null,
      isBusy: false,
      scrollX: window.scrollX || window.pageXOffset,
      scrollY: window.scrollY || document.documentElement.scrollTop,
      btnPageTopStyle: '',
      headerScroll: 0,
    }
  },
  mounted: function () {

    var _self = this

    this.lazyload()
    this.$nextTick(()=> {
      this.lazyload()  
    })
    setTimeout(()=> {
      _self.lazyload()  
    }, 1000)

    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener('scroll', this.commonOnScroll)
    

    this.commonOnResize()
    window.addEventListener('resize', this.commonOnResize)
    window.addEventListener('load', this.commonOnResize)
    

  },
  computed: {
    btnPageTopClass() {
      var ret = 'btnPagetop hover';
      ret += this.$refs.signNav1 || this.$refs.signNav2 ? ' hasSignNav':'';
      ret += this.scrollY < 100 ? ' hide':'';
      this.btnPageTopStyle = this.getBtnPageTopStyle()
      return ret
    }
  },
  methods: {
    isNavActive(reg) {
      var path = window.location.pathname
      reg = new RegExp(reg)
      return reg.test(path)
    },
    getBtnPageTopStyle() {
      var ret = ""
      if (this.$refs.footer) {
        var rect = this.$refs.footer.getBoundingClientRect()
        var tY = Math.min(rect.top - window.innerHeight, 0)
        ret = tY == 0 ? '':'transform: translateY(' + tY + 'px)'
      }
      return ret
    },
    scrollToPageTop() {
      this.$smoothScroll({
        scrollTo: document.body,
        updateHistory: false,
        easingFunction: this.easeInOutSine
      })
    },
    lazyload() {
      var lazyImages = [].slice.call(document.querySelectorAll("img[data-src]:not(.lazy)"));
      var delayBlocks = [].slice.call(document.querySelectorAll(".ld-delay-show:not(.lazy)"));
      
      lazyImages.forEach(function(e) {
        e.classList.add('lazy')
      })
      delayBlocks.forEach(function(e) {
        e.classList.add('lazy')
      })

      if ("IntersectionObserver" in window) {
        
        var lazyImageObserver = new IntersectionObserver(function(entries, observer) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              var lazyImage = entry.target;
              lazyImage.src = lazyImage.dataset.src;
              if (typeof lazyImage.dataset.srcset === "undefined") {
              }else{
                  lazyImage.srcset = lazyImage.dataset.srcset;
              }
              lazyImage.removeAttribute('data-src');
              lazyImageObserver.unobserve(lazyImage);
            }
          });
        });

        lazyImages.forEach(function(lazyImage) {
          lazyImageObserver.observe(lazyImage);
        });
        var delayBlockObserver = new IntersectionObserver(function(entries, observer) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              var block = entry.target;
              block.classList.remove("ld-delay-show");
            }
          });
        });
        
        delayBlocks.forEach(function(b) {
          delayBlockObserver.observe(b);
        });

      } else {
        //IE系
        var lazyImages = [].slice.call(document.querySelectorAll("img"))
        
        
        lazyImages.forEach(function(e) {
          var s = e.getAttribute('data-src')
          if (s) {
            e.src = s;
            e.removeAttribute('data-src');
          }
        })
        delayBlocks.forEach(function(e){
          e.classList.remove("ld-delay-show");
        })
      }

    },

    easeInOutSine(x) {
      return -(Math.cos(Math.PI * x) - 1) / 2;
    },
    easeOutSine(x) {
      return Math.sin((x * Math.PI) / 2);
    },
    commonOnResize() {
      // var appEl = document.getElementById('ld-app')
      // var footer = this.$refs.footer
      // if (appEl && footer) {
      //   appEl.style.paddingBottom = footer.scrollHeight + 'px'
      // }
      this.commonOnScroll()
    },
    commonOnScroll() {
      this.scrollX = window.scrollX || window.pageXOffset
      this.scrollY = window.scrollY || document.documentElement.scrollTop
    },

    handleScroll() {
      this.headerScroll = window.scrollY || window.pageYOffset
    },
    formatDate(timestr, curformat, newformat) {
      return moment(timestr, curformat).format(newformat)
    },

    isNew(timestr, curformat) {
      let now = moment().valueOf()
      let targ = moment(timestr, curformat).add(3, 'day').valueOf()
      return targ>now
    },
    
    getEmergency() {
      var em = null
      this.informations.forEach( (info) => {
        Object.keys(info.categories).forEach( k => {
          if (info.categories[k] == "緊急情報") {
            if (!em) {
              em = info
            }
          }
        })
      })

      return em;
    }
  }
}

module.exports = CommonVueOperation